import { QuizQuestionProps } from "@/pages/quiz/context/types";

const GoodbyeScreen = ({
  question: {
    attributes: { title, subtitle },
  },
}: QuizQuestionProps<boolean>) => (
  <div>
    <h2 className="section-title mb-4">{title}</h2>
    <p className="text-base lg:text-lg font-normal text-black tracking-[-0.0119em]">
      {subtitle}
    </p>

    <div id="feedbackBlock" />
  </div>
);

export { GoodbyeScreen };
